import React, { useEffect, useState } from 'react'
import { Alert, Button, Drawer, Form, Input, message, notification, Popconfirm } from 'antd'
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import Container from '../../../components/Container'
import Main from '../../../components/Main'
import PageHeader from '../../../components/PageHeader'
import AgoraTable from '../../../components/Table';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function Currency() {
    const auth = useAuthUser()
    const [currencyForm] = Form.useForm();
    const [state, setState] = useState({
        gvCurrencyLoading: false,
        gvCurrency: [],
        formOpen: false,
        formType: "Add",
        btnSubmitLoading: false,
        btnSubmitResStatus: "",
        btnSubmitResMsg: "",
        btnDeleteLoading: false,
    })
    const handleSetState = (newState) => {
        setState(prevState => ({
            ...prevState,
            ...newState,
        }))
    }
    useEffect(() => {
        getCurrencyPageLoad()
        // eslint-disable-next-line
    }, [])
    const getCurrencyPageLoad = () => {
        handleSetState({ gvCurrencyLoading: true })
        axios.get(`/Currency/PageLoad`).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    gvCurrencyLoading: false,
                    gvCurrency: resData.Data.gvCurrency
                })
                return resData.Data
            } else {
                message.error(resData.Message)
            }
        }).catch(error => {
            console.log(error)
            message.error(error.message)
        })
    }
    const handleOnFinishCurrency = (formData) => {
        handleSetState({ btnSubmitLoading: true })
        if (state.formType === "Add") {
            axios.post(`/Currency/Create`, {
                currencyCode: formData.currencyCode,
                currencyDesc: formData.currencyDesc,
                createdBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getCurrencyPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        } else if (state.formType === "Edit") {
            axios.post(`/Currency/Update`, {
                currencyId: formData.currencyId,
                currencyCode: formData.currencyCode,
                currencyDesc: formData.currencyDesc,
                modifiedBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getCurrencyPageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        }

    }
    const handleOnDeleteCurrency = () => {
        handleSetState({ btnDeleteLoading: true })
        axios.post(`/Currency/Delete`, {
            currencyId: currencyForm.getFieldValue("currencyId"),
            modifiedBy: auth().userId,
        }).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    formOpen: false,
                    btnDeleteLoading: false
                });
                getCurrencyPageLoad();
                notification.success({
                    message: "Successful",
                    description: resData.Message
                });
            } else {
                handleSetState({
                    btnDeleteLoading: false,
                    btnSubmitResStatus: resData.Status,
                    btnSubmitResMsg: resData.Message,
                });
            }
        }).catch(error => {
            console.log(error);
            message.error(error.message);
        })

    }

    const isAllowToManage = () => {
        if (auth().role === "Admin") {
            return true
        }
        return false;
    }

    return (
        <Main listBreadcrumb={[
            { key: "1", title: "Maintenance" },
            { key: "2", title: "Library" },
            { key: "3", title: "Currency" },
        ]}>
            <Container>
                <PageHeader title="Currency" subtitle="List of currency details.">
                    {isAllowToManage() &&
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                currencyForm.resetFields();
                                handleSetState({
                                    formOpen: true,
                                    formType: "Add",
                                })
                            }}
                        >
                            New Currency
                        </Button>
                    }
                </PageHeader>
                <AgoraTable
                    loading={state.gvCurrencyLoading}
                    dataSource={state.gvCurrency}
                    rowKey="currencyId"
                    columns={[
                        {
                            title: 'Currency Code',
                            dataIndex: 'currencyCode',
                            key: 'currencyCode',
                            dataType: "text",
                            render: (text, record) => <div className="i-x-space-between">
                                <div>{text || "-"}</div>
                                <div className="i-x-right">
                                    {isAllowToManage() &&
                                        <Button className="table-btn edit" size="small" style={{ marginRight: "10px" }}
                                            onClick={() => {
                                                currencyForm.setFieldsValue({
                                                    currencyId: record.currencyId,
                                                    currencyCode: record.currencyCode,
                                                    currencyDesc: record.currencyDesc,
                                                });
                                                handleSetState({
                                                    formOpen: true,
                                                    formType: "Edit",
                                                })
                                            }}
                                        ><EditOutlined /> Edit</Button>
                                    }
                                </div>
                            </div>,
                        },
                        {
                            title: 'Description',
                            dataIndex: 'currencyDesc',
                            key: 'currencyDesc',
                            dataType: "text",
                            render: (text) => text || "-",
                        },
                    ]}
                />
            </Container>
            <Drawer title={`${state.formType} Currency`}
                width={window.innerWidth > 500 ? 500 : window.innerWidth - 80}
                open={state.formOpen}
                extra={
                    <Button type="primary"
                        loading={state.btnSubmitLoading}
                        onClick={() => currencyForm.submit()}
                        icon={state.formType === "Add" ? <PlusOutlined /> : <SaveOutlined />}
                    >
                        {state.formType === "Add" ? "Add" : "Update"}
                    </Button>
                }
                onClose={() => {
                    currencyForm.resetFields()
                    handleSetState({
                        formType: "Add",
                        formOpen: false,
                        btnSubmitResStatus: "",
                        btnSubmitResMsg: "",
                    })
                }}
            >
                <div className="i-y-100 i-y-space-between">
                    <Form
                        form={currencyForm}
                        name="currency-form"
                        layout="vertical"
                        size="middle"
                        requiredMark={false}
                        onFinish={handleOnFinishCurrency}
                    >
                        {state.btnSubmitResStatus !== ""
                            && <Alert type="error" showIcon style={{ margin: "0px 25px 20px 0px" }}
                                message={state.btnSubmitResMsg}
                            />
                        }
                        <Form.Item hidden={true} name="currencyId" ></Form.Item>
                        <Form.Item
                            label="Currency Code"
                            name="currencyCode"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter currency code!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., SGD' />
                        </Form.Item>
                        <Form.Item
                            label="Description"
                            name="currencyDesc"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter currency description!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., Singapore Dollar' />
                        </Form.Item>
                    </Form>
                    {state.formType === "Edit"
                        ? <div>
                            <Popconfirm
                                title="Delete currency"
                                description="Are you sure to delete this currency?"
                                onConfirm={handleOnDeleteCurrency}
                                okText="Yes"
                                okType="danger"
                            >
                                <Button type="primary" danger block loading={state.btnDeleteLoading}
                                    icon={<DeleteOutlined />}
                                >Delete Currency</Button>
                            </Popconfirm>
                        </div>
                        : ""
                    }
                </div>
            </Drawer>
        </Main>
    )
}

export default Currency